module.exports = __webpack_public_path__ + "img/palos-front.054ab084.png";